import {
  ColDef,
  ICellRendererParams,
  ValueGetterParams,
} from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createCustomCol,
  createDateHasMinCol,
  createDetailButtonColV2,
  createIdCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import Badge from '@/src/components/atom/Badge';
import dayjs from 'dayjs';
import InquiryDto from '@/src/models/InquiryDto';

export const inquiryListColumn = (
  onDetailClick: (value: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasMinCol({
    field: 'createdAt',
    width: 131,
    minWidth: 131,
    maxWidth: 231,
    headerName: '등록 일시',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'inquiryAnswerStatus',
    width: 120,
    minWidth: 120,
    maxWidth: 120,
    cellRenderer: (params: ValueGetterParams) => {
      if (params?.data?.inquiryAnswerStatus === '답변 완료') {
        return (
          <Badge badgeColor="lightGray">
            {params.data.inquiryAnswerStatus}
          </Badge>
        );
      } else {
        return (
          <Badge badgeColor="lightRed">{params.data.inquiryAnswerStatus}</Badge>
        );
      }
    },
    headerName: '답변 상태',
  },
  createTypoCol({
    field: 'inquiryCategory',
    width: 120,
    minWidth: 120,
    maxWidth: 200,
    headerName: '문의 유형',
  }),
  createTypoCol({
    field: 'content',
    width: 200,
    minWidth: 200,
    headerName: '내용',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'nick',
    width: 135,
    minWidth: 135,
    maxWidth: 200,
    cellRenderer: (params: ValueGetterParams) => {
      return params?.data?.customer?.nick || '-';
    },
    headerName: '닉네임',
  },
  {
    field: 'answerCreatedAt',
    headerClass: 'ag-right-aligned-cell',
    cellStyle: { textAlign: 'center' },
    width: 131,
    minWidth: 131,
    maxWidth: 231,
    flex: 1,
    cellRenderer: ({ data }: ValueGetterParams) => {
      const value: string = data?.inquiryAnswer?.createdAt
        ? dayjs(data?.inquiryAnswer?.createdAt).format('YYYY-MM-DD HH:mm')
        : '-';
      return value;
    },
    headerName: '답변 일시',
  },
  createCustomCol({
    field: 'adminName',
    headerName: '답변 관리자',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams<InquiryDto>) => {
      return data?.inquiryAnswer?.administrator?.name || '-';
    },
  }),
  createDetailButtonColV2(onDetailClick),
];
